import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import {
  PaymentIntentAuthentication as SharedPaymentIntentAuthentication,
  type PaymentIntentAuthenticationProps,
} from "@bw/shared/components";

export type MaterialPaymentIntentAuthenticationProps = Omit<
  PaymentIntentAuthenticationProps,
  "render"
> & { authenticationFailureMessage?: string };

/** Player-native MUI presentation over shared SCA + reconciliation state. */
export function MaterialPaymentIntentAuthentication(
  props: MaterialPaymentIntentAuthenticationProps,
) {
  const { authenticationFailureMessage, ...authenticationProps } = props;
  return (
    <SharedPaymentIntentAuthentication
      {...authenticationProps}
      render={(model) => (
        <Stack spacing={1.5} role="status" sx={{ alignItems: "flex-start" }}>
          {model.error ? (
            <Alert severity="error" role="alert" sx={{ width: "100%" }}>
              {model.phase === "authentication_failed" &&
              authenticationFailureMessage
                ? authenticationFailureMessage
                : model.message}
            </Alert>
          ) : (
            <Typography variant="body2">{model.message}</Typography>
          )}
          <Box>
            <Button
              type="button"
              variant="contained"
              onClick={model.authenticate}
              disabled={model.actionDisabled}
              aria-busy={model.busy || undefined}
            >
              {model.actionLabel}
            </Button>
          </Box>
        </Stack>
      )}
    />
  );
}
